<!--
    タイトルバーのコンポーネント

    AbsListUtilから抜き出し。
    AbsListUtilの設計ではListUtilを直接操作したい場合や、ListUtilのデザインを変えたい場合など、AbsListUtilの無駄な拡張が必要になる。
    コンポーネントをそれぞれ分けて呼び出し元ので定義することで上記の無駄が発生しないようにした。

    使用例：
    ListUtilと組み合わせてご利用ください
    <div class="d-flex flex-column flex-grow-1">
        <ListTitleBar ...></ListTitleBar>
        <ListUtil ...></ListUtil>
    </div>
-->
<template>
    <div class="title-belt-table-no-center d-flex flex-wrap">
        <div class="d-flex" style=" min-height: 43px;">
            <template v-if="isUseMenuItemList === true && selectCount > 0">
                <div class="d-flex" style="height: 40px; border-radius: 4px; background-color: #64CDFF">
                    <div class="d-flex align-items-center">
                        <span style="margin-left:16px; margin-right:16px; font-size: 14px; font-weight: 700; color: #fff;">{{selectCount}}{{unit}}選択中</span>
                    </div>
                    <div v-if="isShowOperationButton" class="d-flex align-items-center">
                        <BGColorMenuButton label="操作" style="width: 88px; margin-right: 4px;" />
                        <div class="dropdown-menu scv-dropdown-menu" aria-labelledby="navbarDropdown">
                            <OperationMenu :models="menuItemList"
                                       @onClickMenuItem="onClickMenuItem"
                        />
                        </div>
                    </div>
                </div>
                <div style="min-width: 12px;"></div>
            </template>
            <template v-else-if="0 < titleCaption.length">
                <span class="title-belt-table-no-center-text" :style="titleStyle">{{titleCaption}}</span>
                <slot name="label">
                </slot>
                <div style="min-width: 12px;"></div>
            </template>
        </div>

        <div class="d-flex flex-row full-width flex-grow-1" style="padding-top: 4px; height: 43px;">
            <template v-if="selectmenuItemList && selectmenuItemList.length > 0">
                <BGColorMenuButton v-bind:label=MenuItemListCaption style="width: 119px" class="listBtnLayout" />
                <div class="dropdown-menu keep-open-on-click scv-dropdown-menu" aria-labelledby="navbarDropdown">
                    <SelectMenu :models="selectmenuItemList"
                                @onChangeMenuItem="onChangeMenuItem" />
                </div>
                <div style="min-width: 16px;"></div>
            </template>
            <template v-if="leftMenuItemListCaption && leftMenuItemList && leftMenuItemList.length > 0">
                <BGColorMenuButton v-bind:label=leftMenuItemListCaption :downIcon="false" :designType="1" style="width: 64px" class="listBtnLayout" />
                <div class="dropdown-menu scv-dropdown-menu" aria-labelledby="navbarDropdown">
                    <OperationMenu :models="leftMenuItemList" @onClickMenuItem="onClickLeftMenuItem" />
                </div>
                <div style="min-width: 8px;"></div>
            </template>
            <template v-if="titleBotton_1">
                <button type="button" class="btn-scv-white-small listBtnLayout "
                        v-bind:disabled="disabled || isBtnActive(btnActiveType_Title1)"
                        @click="onBtnTitleClicked_1"
                        v-bind:style="additionalTitleClass_1">
                    {{titleBotton_1}}
                </button>
            </template>
            <template v-if="btnCaption_1 || btnCaption_2 || btnCaption_3">
                <template v-if="titleBotton_1">
                    <div style="min-width: 16px;"></div>
                </template>
                <template v-if="btnCaption_1">
                    <template v-if="btnDescription_1">
                        <div style="margin: 0px 8px;">
                            <span class="title-belt-table-no-center-text" :style="btnDescriptionStyle_1">{{btnDescription_1}}</span>
                        </div>
                    </template>
                    <button type="button" class="btn-scv-white-small listBtnLayout "
                            v-bind:disabled="disabled || isBtnActive(btnActiveType_1) || isBtndisabled_1"
                            @click="onBtnClicked_1"
                            v-bind:style="additionalClass_1">
                        {{btnCaption_1}}
                    </button>
                </template>
                <template v-if="btnCaption_2">
                    <template v-if="btnCaption_1">
                        <div style="margin-left: 8px;"></div>
                    </template>
                    <template v-if="btnDescription_2">
                        <div style="margin: 0px 8px;">
                            <span class="title-belt-table-no-center-text" :style="btnDescriptionStyle_2">{{btnDescription_2}}</span>
                        </div>
                    </template>
                    <button type="button" class="btn-scv-white-small listBtnLayout"
                            v-bind:disabled="disabled || isBtnActive(btnActiveType_2) || isBtndisabled_2"
                            @click="onBtnClicked_2"
                            v-bind:style="additionalClass_2">
                        {{btnCaption_2}}
                    </button>
                </template>
                <template v-if="btnCaption_3">
                    <template v-if="btnCaption_1 || btnCaption_2">
                        <div style="margin-left: 8px;"></div>
                    </template>
                    <template v-if="btnDescription_3">
                        <div style="margin: 0px 8px;">
                            <span class="title-belt-table-no-center-text" :style="btnDescriptionStyle_3">{{btnDescription_3}}</span>
                        </div>
                    </template>
                    <button type="button" class="btn-scv-white-small listBtnLayout"
                            v-bind:disabled="disabled || isBtnActive(btnActiveType_3) || isBtndisabled_3"
                            @click="onBtnClicked_3"
                            v-bind:style="additionalClass_3">
                        {{btnCaption_3}}
                    </button>
                </template>
            </template>
            <template v-if="btnCaption_4">
                <template v-if="btnCaption_1 || btnCaption_2 || btnCaption_3">
                    <div style="margin-left: 8px;"></div>
                </template>
                <template v-if="btnDescription_4">
                    <div style="margin: 0px 8px;">
                        <span class="title-belt-table-no-center-text" :style="btnDescriptionStyle_4">{{btnDescription_4}}</span>
                    </div>
                </template>
                <button type="button" class="btn-scv-white-small listBtnLayout"
                        v-bind:disabled="disabled || isBtnActive(btnActiveType_4)"
                        @click="onBtnClicked_4"
                        v-bind:style="additionalClass_4">
                    {{btnCaption_4}}
                </button>
            </template>
            <template v-if="btnCaption_5">
                <template v-if="btnCaption_1 || btnCaption_2 || btnCaption_3 || btnCaption_4">
                    <div style="margin-left: 8px;"></div>
                </template>
                <template v-if="btnDescription_5">
                    <div style="margin: 0px 8px;">
                        <span class="title-belt-table-no-center-text" :style="btnDescriptionStyle_5">{{btnDescription_5}}</span>
                    </div>
                </template>
                <button type="button" class="btn-scv-white-small listBtnLayout"
                        v-bind:disabled="disabled || isBtnActive(btnActiveType_5)"
                        @click="onBtnClicked_5"
                        v-bind:style="additionalClass_5">
                    {{btnCaption_5}}
                </button>
            </template>
            <template v-if="enableSearchText || btnCaption_r1 || rowCountArea || isUseRightMenuItemList">
                <div class="d-flex flex-row ms-auto align-items-start">
                    <div v-if="(selectmenuItemList && selectmenuItemList.length > 0) || titleBotton_1 || btnCaption_1 || btnCaption_2 || btnCaption_3 || btnCaption_4 || btnCaption_5" style="min-width: 24px;"></div>
                    <template v-if="enableSearchText">
                        <SearchInput convertType="text"
                                     v-model="searchText"
                                     autocomplete="off"
                                     @keydown.enter="onSearchBoxKeydown"
                                     v-bind:maxlength="SEARCHEBOX_MAX_LENGTH"
                                     :style="{'min-width': widthSearchBox + 'px', 'max-width': widthSearchBox + 'px', 'margin': '0px 8px 0px 0px'}" />
                        <button id="clearButton" class="btn-scv-white-small listBtnLayout" @click="onBtnClear" v-bind:disabled="'' === searchedText">解除</button>
                    </template>
                    <template v-if="btnCaption_r1">
                        <template v-if="btnCaption_1 || btnCaption_2 || btnCaption_3 || enableSearchText">
                            <div style="margin-left: 8px;"></div>
                        </template>
                        <button type="button" class="btn-scv-white-small listBtnLayout"
                                v-bind:disabled="disabled || isBtnActive(btnActiveType_r1)"
                                @click="onBtnClicked_r1"
                                v-bind:style="additionalClass_r1 ">
                            {{btnCaption_r1}}
                        </button>
                    </template>
                    <template v-if="rowCountArea">
                        <template v-if="enableSearchText || btnCaption_r1">
                            <div style="width: 8px;"></div>
                        </template>
                        <input type="text" class="input-text-scv ms-auto" style="width:64px; height:32px;" :value="rowCount" readonly>
                    </template>
                    <template v-if="isUseRightMenuItemList">
                        <template v-if="enableSearchText || btnCaption_r1 || rowCountArea">
                            <div style="margin-left: 8px;"></div>
                        </template>
                        <button class="btn-scv-bgcolor btn-icon" data-bs-toggle="dropdown">
                            <div class="d-flex align-items-center justify-content-center">
                                <div class="icon-font-deepblue">
                                    <i class="icon-menu"></i>
                                </div>
                            </div>
                        </button>
                        <div class="dropdown-menu scv-dropdown-menu">
                            <OperationMenu :models="rightMenuItemList"
                                           @onClickMenuItem="onClickRightMenuItem" />
                        </div>
                    </template>
                    <!-- 拡大表示ボタン -->
                    <template v-if="isBtnExpand">
                        <button class="btn-scv-bgcolor btn-icon" style="margin-left: 8px;" @click="isExpand ? onBtnClicked_Shrink() : onBtnClicked_Expand()">
                            <div class="d-flex align-items-center justify-content-center">
                                <div class="icon-font-deepblue">
                                    <i :class="isExpand ? 'icon-screen_undo' : 'icon-screen_full'"></i>
                                </div>
                            </div>
                        </button>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import SearchInput from '@/components/Input/SearchInput.vue'
    import BGColorMenuButton from '@/components/Button/BGColorMenuButton.vue';
    import OperationMenu from '@/components/ListMenu/OperationMenu.vue';
    import SelectMenu from '@/components/ListMenu/SelectMenu.vue';

    @Options({
        components: {
            SearchInput,
            BGColorMenuButton,
            OperationMenu,
            SelectMenu,
        },
        props: {
            /*
             * タイトル
             */
            titleCaption: { type: String, default: "" },

            /*
             * タイトルのスタイル
             */
            titleStyle: { type: String, default: "" },

            /*
             * タイトルボタン
             */
            titleBotton_1: { type: String },
            /*
             * ボタン名
             */
            btnCaption_1: { type: String },
            btnCaption_2: { type: String },
            btnCaption_3: { type: String },
            btnCaption_4: { type: String },
            btnCaption_5: { type: String },

            btnCaption_r1: { type: String },

            /*
             * ボタン説明テキスト(ボタンの前に表示されます。例：ADEプロファイル管理画面)
             */
            btnDescription_1: { type: String },
            btnDescription_2: { type: String },
            btnDescription_3: { type: String },
            btnDescription_4: { type: String },
            btnDescription_5: { type: String },

            /*
             * ボタン説明テキストのスタイル
             */
            btnDescriptionStyle_1: { type: String },
            btnDescriptionStyle_2: { type: String },
            btnDescriptionStyle_3: { type: String },
            btnDescriptionStyle_4: { type: String },
            btnDescriptionStyle_5: { type: String },

            /*
             * 0 : 常にアクティブ
             * 1 : 単一選択時にのみアクティブ
             * 2 : 複数選択時にのみアクティブ
             * 3 : 単一又は複数選択時にのみアクティブ
             * 4 : リストにデータが1つ以上あるときのみアクティブ
             * 5 : 非アクティブ
             */
            btnActiveType_Title1: { type: Number, default: 0 },
            btnActiveType_1: { type: Number, default: 0 },
            btnActiveType_2: { type: Number, default: 0 },
            btnActiveType_3: { type: Number, default: 0 },
            btnActiveType_4: { type: Number, default: 0 },
            btnActiveType_5: { type: Number, default: 0 },

            btnActiveType_r1: { type: Number, default: 0 },
            /*
             * ボタンのスタイル
             */
            additionalTitleClass_1: { type: Object, Default: {} },
            additionalClass_1: { type: Object, Default: {} },
            additionalClass_2: { type: Object, Default: {} },
            additionalClass_3: { type: Object, Default: {} },
            additionalClass_4: { type: Object, Default: {} },
            additionalClass_5: { type: Object, Default: {} },

            isBtndisabled_1: { type: Boolean, default: false },  /* 強制的にボタン1をDisableにする*/
            isBtndisabled_2: { type: Boolean, default: false },  /* 強制的にボタン2をDisableにする*/
            isBtndisabled_3: { type: Boolean, default: false },  /* 強制的にボタン3をDisableにする*/

            additionalClass_r1: { type: Object, Default: {} },
            /*
             * カウンター
             */
            rowCountArea: { type: Boolean, default: false }, /* カウンターの有無 */
            rowCount: { type: Number, default: 0 }, /* カウント数 */
            /*
             * その他
             */
            disabled: { type: Boolean, default: false },   /* 強制的にボタンをDisableにする*/
            selectCount: { type: Number, default: 0 },     /* 現在の選択数（ボタンのDisable判定に利用） */
			unit: { type: String, default: "件" },     /* 現在の選択数の単位（ボタンのDisable判定に利用） */
            /*
             * 文字検索
             */
            enableSearchText: { type: Boolean, Default: false },    /* 文字列検索バーの有無 */

            /*操作ボタン押下時のリスト: Array<MenuItemBase> */
            menuItemList: { type: Array, default: [] },

            /*x件選択中を表示するか */
            isUseMenuItemList: { type: Boolean, default: false },
            /*x件選択中の横に操作ボタンを使用するか */
            isShowOperationButton: { type: Boolean, default: true },

            /*表示設定押下時のチェックボックスリスト: Array<MenuItemBase> */
            selectmenuItemList: { type: Array, default:  [] },

            /*メニューリストキャプション*/
            MenuItemListCaption: { type: String, default: "表示設定" },

            // 左側に表示するリスト: Array<MenuItemBase>
            leftMenuItemList: { type: Array, default:  [] },

            // 左側に表示するメニューリストキャプション
            leftMenuItemListCaption: { type: String },

            /*「三」押下時のリスト: Array<MenuItemBase> */
            rightMenuItemList: { type: Array, default:  [] },

            /*表示設定ボタンを使用するか */
            isUseRightMenuItemList: { type: Boolean, default: false },

            /*検索ボックスの幅指定 */
            widthSearchBox: { type: Number, default: 240 },

            // 拡大表示ボタンを表示するかどうか
            isBtnExpand: { type: Boolean, default: false },
        },
        emits: [
            'onBtnTitleClicked_1',
            'onBtnClicked_1',
            'onBtnClicked_2',
            'onBtnClicked_3',
            'onBtnClicked_4',
            'onBtnClicked_5',
            'onBtnClicked_r1',

            /*
             * メニューアイテムをクリックしたときの処理
             * @param[in] selectId : メニューアイテムID
             */
            'onClickMenuItem',
            /*
             * 文字検索開始（Enter押下）
             * @param[in] searchText : 検索文字列
             */
            'onSearchBoxKeydown',

            /*
             * 文字検索終了（解除押下）
             */
            'onBtnClear',

            /*
             * プルダウンのメニューアイテムをチェックしたときの処理
             * @param[in] checkedIdList : チェックされているメニューアイテムID
             */
            'onChangeMenuItem',

            /*
             * メニューアイテム(左)をクリックしたときの処理
             * @param[in] selectId : メニューアイテムID
             */
            'onClickLeftMenuItem',

            /*
             * メニューアイテム(右)をクリックしたときの処理
             * @param[in] selectId : メニューアイテムID
             */
            'onClickRightMenuItem',
            
            /*
             * 拡大表示／縮小ボタンをクリックしたときの処理
             */
            'onBtnClicked_Expand',
            'onBtnClicked_Shrink',
        ],
    })

    export default class ListTitleBar extends Vue {
        // 定義
        private readonly SEARCHEBOX_MAX_LENGTH = 100;

        private rowCount!: number;
        private selectCount!: number;

        // 入力文字列
        private searchText = "";
        private searchedText = "";

        // 拡大表示モードの状態
        // true: open
        // false : close
        private isExpand: boolean = false;

        // タイトルボタン１
        public onBtnTitleClicked_1(): void {

            // 親にクリックされたことを通知
            this.$emit("onBtnTitleClicked_1");
        }

        // ボタン１
        public onBtnClicked_1(): void {

            // 親にクリックされたことを通知
            this.$emit("onBtnClicked_1");
        }

        // ボタン２
        public onBtnClicked_2(): void {

            // 親にクリックされたことを通知
            this.$emit("onBtnClicked_2");
        }

        // ボタン３
        public onBtnClicked_3(): void {

            // 親にクリックされたことを通知
            this.$emit("onBtnClicked_3");
        }

        // ボタン４
        public onBtnClicked_4(): void {

            // 親にクリックされたことを通知
            this.$emit("onBtnClicked_4");
        }

        // ボタン５
        public onBtnClicked_5(): void {

            // 親にクリックされたことを通知
            this.$emit("onBtnClicked_5");
        }

        // ボタンr1
        public onBtnClicked_r1(): void {

            // 親にクリックされたことを通知
            this.$emit("onBtnClicked_r1");
        }

        // ボタンのアクティブ切り替え
        public isBtnActive(btnActiveType: number): boolean {

            /*
             * 0 : 常にアクティブ
             * 1 : 単一選択時にのみアクティブ
             * 2 : 複数選択時にのみアクティブ
             * 3 : 単一又は複数選択時にのみアクティブ
             * 4 : リストにデータが1つ以上あるときのみアクティブ
             * 5 : 非アクティブ
             */
            switch (btnActiveType) {
                case 1:
                    if (1 == this.selectCount) {
                        return false;
                    }
                    break;
                case 2:
                    if (2 <= this.selectCount) {
                        return false;
                    }
                    break;
                case 3:
                    if (1 <= this.selectCount) {
                        return false;
                    }
                    break;
                case 4:
                    if (1 <= this.rowCount) {
                        return false;
                    }
                    break;
                case 5:
                    return true
                case 0:
                default:
                    return false;
            }

            return true;  // 非アクティブ
        }


        /*
         * ListTitleBarの初期化
         */
        public initListTitleBar(): void {
            // 検索文字列を初期化する
            this.searchedText = "";
            this.searchText = "";
        } 

        /*
         * 文字検索開始（Enter押下）
         */
        private onSearchBoxKeydown(): void {
            this.searchedText = this.searchText;
            this.$emit("onSearchBoxKeydown", this.searchedText);
        }

        /**
         * 文字検索開始
         * @param searchWord 検索する文言
         */
        public SearchStart(searchWord: string) {
            this.searchText = searchWord;
            this.onSearchBoxKeydown();
        }

        /*
         * 文字検索終了（解除押下）
         */
        private onBtnClear(): void {
            this.searchedText = "";
            this.searchText = "";
            this.$emit("onBtnClear");
        }

        /**
         * メニューアイテムクリック時の処理
         */
        public onClickMenuItem(selectId: number): void {
            this.$emit("onClickMenuItem", selectId);
        }

        /**
         * メニューアイテム選択変更時の処理
         */
        public onChangeMenuItem(checkedIdList : number[]): void {
            this.$emit("onChangeMenuItem", checkedIdList); 
        }
        
        /**
         * メニューアイテム(左)クリック時の処理
         */
        public onClickLeftMenuItem(selectId: number): void {
            this.$emit("onClickLeftMenuItem", selectId);
        }
        
        /**
         * メニューアイテム(右)クリック時の処理
         */
        public onClickRightMenuItem(selectId: number): void {
            this.$emit("onClickRightMenuItem", selectId);
        }

        /**
         * 拡大表示ボタンクリック時の処理
         */
        public onBtnClicked_Expand(): void {
            // 押下通知
            this.$emit("onBtnClicked_Expand");
            // OPEN状態に設定
            this.isExpand = true;
        }

        /**
         * 縮小ボタンクリック時の処理
         */
        public onBtnClicked_Shrink(): void {
            // 押下通知
            this.$emit("onBtnClicked_Shrink");
            // CLOSE状態に設定
            this.isExpand = false;
        }
    }
</script>

<style scoped>
    .listBtnLayout {
        min-width: max-content;
        width: 64px;
        height: 32px;
    }
</style>
